export const environment = {
  production: true,
  envName: 'production',
  extwsBaseUrl: 'https://www.autotalli.com/v1_9/'
};
